import React, { Fragment } from "react";

import "./json.css";
import JSONPretty from "react-json-pretty";
import { TitleRequestResponse, ContainerRequestResponse } from "./styles";

const LOADING_IMG = "/images/loading.gif";
const LUP_IMG = "/images/lup.png";
const ERROR_IMG = "/images/errorService.png";
const SUCCESS_IMG = "/images/success.png";

const Template = ({ name, request, response, text, image }) => {
  if (name === "") {
    return null;
  }

  if (name === "loader") {
    return (
      <Fragment>
        <h3 style={{ fontSize: 15, fontWeight: "300" }}>
          Procesando Solicitud
        </h3>
        <img
          src={LOADING_IMG}
          alt="Loader.gif"
          width="160px"
          height="160px"
          style={{ marginTop: "27px" }}
        />
      </Fragment>
    );
  }
  if (name === "load-Login") {
    return (
      <Fragment>
        <h3 style={{ fontSize: 15, fontWeight: "300" }}>Iniciando Sesión</h3>
        <img
          src={LOADING_IMG}
          alt="Loader.gif"
          width="160px"
          height="160px"
          style={{ marginTop: "27px" }}
        />
      </Fragment>
    );
  }
  if (name === "notFound") {
    return (
      <Fragment>
        <h3 style={{ fontSize: 15, fontWeight: "300", marginBottom: "10px" }}>
          No se Encontraron Resultados
        </h3>

        <img
          src={LUP_IMG}
          alt="lup.png"
          width="160px"
          height="160px"
          style={{ marginTop: "27px", marginBottom: "10px" }}
        />
      </Fragment>
    );
  }

  if (name === "error") {
    return (
      <Fragment>
        <h3 style={{ fontSize: 15, fontWeight: "300", marginBottom: "10px" }}>
          Tenemos un error al procesar la solicitud
        </h3>
        <br />
        <p>{response}</p>

        <img
          src={ERROR_IMG}
          alt="Loader.gif"
          width="130px"
          height="130px"
          style={{ marginTop: "37px", marginBottom: "10px" }}
        />
      </Fragment>
    );
  }

  if (name === "success") {
    return (
      <Fragment>
        <h3 style={{ fontSize: 15, fontWeight: "300", marginBottom: "10px" }}>
          Se Proceso Con Exito
        </h3>

        <img
          src={SUCCESS_IMG}
          alt="Loader.gif"
          width="130px"
          height="130px"
          style={{ marginTop: "37px", marginBottom: "10px" }}
        />
      </Fragment>
    );
  }

  if (name === "login-invalid") {
    return (
      <Fragment>
        <h3 style={{ fontSize: 15, fontWeight: "300", marginBottom: "10px" }}>
          { text }
        </h3>

        <img
          src={image}
          alt="Loader.gif"
          width="130px"
          height="130px"
          style={{ marginTop: "37px", marginBottom: "10px" }}
        />
      </Fragment>
    );
  }

  if (name === "personalized") {
    return (
      <Fragment>
        <h2 style={{ fontSize: 15, fontWeight: "300", marginBottom: "10px" }}>
          { text }
        </h2>

        <img
          src={image}
          alt="Loader.gif"
          width="130px"
          height="130px"
          style={{ marginTop: "37px", marginBottom: "10px" }}
        />
      </Fragment>
    );
  }

  if (name === "requestModal") {
    return (
      <Fragment>
        <TitleRequestResponse>Request</TitleRequestResponse>
        <hr></hr>
        <br></br>
        <ContainerRequestResponse>
          <p>
            <JSONPretty id="json-pretty" data={request}></JSONPretty>
          </p>
        </ContainerRequestResponse>

        <TitleRequestResponse>Response</TitleRequestResponse>
        <hr></hr>
        <br></br>
        <ContainerRequestResponse>
          <p>
            <JSONPretty id="json-pretty" data={response}></JSONPretty>
          </p>
        </ContainerRequestResponse>
      </Fragment>
    );
  }
};

export default Template;
